import { getSystemsCatalog } from 'common/api/v1/systems';

import {
    FETCH_SYSTEMS_CATALOG,
    FETCH_SYSTEMS_CATALOG_FAILURE,
    FETCH_SYSTEMS_CATALOG_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default ({ searchText } = {}) =>
    (dispatch) => {
        dispatch(actions[FETCH_SYSTEMS_CATALOG]());

        getSystemsCatalog({ searchText })
            .then((response) => {
                dispatch(
                    actions[FETCH_SYSTEMS_CATALOG_SUCCESS](response.data.data),
                );
            })
            .catch((error) =>
                dispatch(
                    actions[FETCH_SYSTEMS_CATALOG_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
